<template>
  <div class="pro_page_content Page" v-show="isRouterAlive">
    <div class="Page-Content row">
      <div class="pro_page_header_div select-none">
        <div
          @click="RightShow = !RightShow"
          v-if="isPhone"
          :class="{ clickRightShow: RightShow }"
          class="round_btn_div"
          style="
            background: black;
            justify-content: center;
            padding: 4px 0;
            font-size: 0.5rem;
            width: 99%;
            text-align: center;
            color: #ddd;
            font-weight: 700;
            padding-left: 0px;
          "
        >
          Navigation
        </div>
        <div style="font-size: 1.5rem;font-weight: 500;text-align: start">Floor Plan</div>
        <div style="width: 100%;margin: auto;" class="btn_list" v-if="!isPhone">
          <div
            class="btn_header"
            v-for="(i, index) in unit_type_list"
            :key="index"
            @click="btn_n = index" 
          >
          <div style="background-color: black;height: 2px;width: 100%;"></div>
          <!-- :style="`background:${i.color};text-align: start;`" -->
            <div class="round_btn_div row" style="justify-content:start;">
              <div style="width:15px;height:15px;margin-bottom: 5px;margin-right: 5px;border-radius: 50%;" :style="`background: ${i.color};`" ></div>
              <span>{{ i.name }}</span>
            </div>
            <div 
            style="margin-left: 20px;text-align: start;margin-bottom:5px"
            v-show="btn_n == index" 
            v-for="(n, index2) in i.to_type" 
            @click="setanimation(n.typecls, n.imgnames, n.name)" 
            :class="{ clickbtns: RightBtnIndex == n.name }" 
            :key="index2">
              <span > {{ n.name }}</span>
            </div>

              <!-- <ul v-show="btn_n == index">
                <li v-for="(n, index2) in i.to_type" :key="index2">
                  <div
                    :style="`background: ${i.color};text-align: start;display: flex;flex-direction: row;align-items: center;`"
                    class="round_btn_div"
                    :class="{ clickbtns: RightBtnIndex == n.name }"
                    @click="setanimation(n.typecls, n.imgnames, n.name)"
                  >
                    {{ n.name }}
                    <a
                      style="display: flex"
                      :href="n.ivt"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        v-if="n.ivt"
                        style="width: 25px; margin-left: 10px"
                        src="@/assets/btn/button-27.png"
                        alt=""
                    /></a>
                  </div>
                </li>
              </ul> -->
          </div>
          <p style="text-align: start;font-size: 16px;font-weight: bold;">Click on Stack for Floor Plan</p>
        </div>
      </div>

      <div class="right-bar" v-if="RightShow && isPhone">
        <div class="btn_list">
          <div
            class="right-bar-btn_header"
            v-for="(i, index) in unit_type_list"
            :key="index"
          >
            <template>
              <div
                class="right-bar-btn-div"
                @click="btn_n = index"
                :class="{ rightclickbtn: btn_n == index }"
              >
                {{ i.name }}
                <svg
                  t="1637142576371"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  width="14"
                  height="14"
                >
                  <path
                    d="M517.688889 796.444444c-45.511111 0-85.333333-17.066667-119.466667-51.2L73.955556 381.155556c-22.755556-22.755556-17.066667-56.888889 5.688888-79.644445 22.755556-22.755556 56.888889-17.066667 79.644445 5.688889l329.955555 364.088889c5.688889 5.688889 17.066667 11.377778 28.444445 11.377778s22.755556-5.688889 34.133333-17.066667l312.888889-364.088889c22.755556-22.755556 56.888889-28.444444 79.644445-5.688889 22.755556 22.755556 28.444444 56.888889 5.688888 79.644445L637.155556 739.555556c-28.444444 39.822222-68.266667 56.888889-119.466667 56.888888 5.688889 0 0 0 0 0z"
                    p-id="2427"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
            </template>
            <template>
              <ul v-show="btn_n == index">
                <li v-for="(n, index2) in i.to_type" :key="index2">
                  <div
                    :class="{ rightclickbtn: RightBtnIndex == n.name }"
                    class="right-round_btn_div"
                    @click="setanimation(n.typecls, n.imgnames, n.name)"
                  >
                    {{ n.name }}
                  </div>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>

      <div v-if="loadingindex" class="loading_div">
        <div style="color: white;font-size: 2rem;">Loading...{{ Math.round(loadingindex) }}%</div>
      </div>

      <div class="pro_page_models_div" @click="RightShow = false">
        <div class="model-outline-border">
          <div
            align="justify"
            class="img3dmodels"
            ref="img3dmodels"
            :style="`top:${y}px;left:${x}px;transform: scale(1.7);`"
            @touchstart="phonetouchstart"
            @touchmove="phonetouchmove"
            @touchend="phonetouchend"
            @mousedown="move"
            @mousewheel.prevent="zoomsize"
            @mouseout="zoomremove"
          >
            <ul
              style="
                padding-inline-start: 0px;
                pointer-events: none;
                margin-block-start: 0em;
                margin-block-end: 0em;
              "
            >
              <li
                style="width: 100%; pointer-events: none; list-style-type: none"
                v-show="index == n"
                v-for="(i, index) in imglist"
                :key="index"
              >
                <!-- <img
                  v-if="newgb"
                  style="width: 100%; pointer-events: none; z-index: 999"
                  src="@/assets/model/00004_1.png"
                  alt=""
                /> -->
                <img style="width: 100%; pointer-events: none" :src="i" />
              </li>
            </ul>
            <div id="animation_div" v-if="animation_list != []">
              <div
                class="animation"
                :style="`width: ${i.w}; height: ${i.h}; left: ${i.x}; top: ${i.y}; border-color: ${i.color};
                background-image: url(${require('@/assets/img/' + i.ctname + '.png')});
                background-size:100% 100%;background-repeat:no-repeat;border:0px;`"
                v-for="(i, index3) in animation_list"
                :key="index3"
                @click="goUnit(i)"
              >
                <!-- <div v-if="toPoint(i.h) > 10 " class="animation_for_size_div">
                  <span v-for="a in 2" :key="a">{{i.ctname}}</span>
              </div>
              <div v-else class="animation_for_size_div"><span>{{i.ctname}}</span></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="popMedia" style="position: absolute;width: 100%; height: 100%;z-index: 999;">
        <!-- <div @click="popMedia = false" style="position: absolute;width: 100%; height: 100%;background-color: #3c3c3c96;"></div> -->
        <div style="position: absolute;top: 50%;left: 50%;width: 100%;height: 100%;background-color: #000;transform: translate(-50%, -50%);box-shadow: 1px 1px 10px #00000066;display: flex;justify-content: center;align-items: center;">
          <img style="max-width: 100%;max-height: 100%;" :src="popMedia.url" alt="">
          <div @click="popMedia = false" style="position: absolute;top: 49%;right: 10px;z-index: 999;color: black;cursor: pointer;background-color: white;padding: 2px 4px;border-radius: 2px;">close</div>
        </div>
      </div>
    </div>


  </div>
</template>



<script>
import TWEEN from "tween.js/src/Tween.js";

export default {
  data() {
    return {
      popMedia: null,
      newgb: false,
      imgs: [],
      positionY_1: 0,
      btn_n: null,
      loading: 0,
      loadingindex: 0,
      unit_type_list: this.$Datas.unit_type_list,
      imglist: [],
      imgeurl: require("@/assets/model/00000.png"),
      markindex: 0,
      n: 0,
      fangm: 1.7,
      rotatingtype: false,
      interval: null,
      animation_list: [],
      RightBtnIndex: "",
      RightShow: false,
      isRouterAlive: true,
      isPhone: false,
      intervalId: null,
      deviatorX: 0,
      deviatorY: 0,
      x: 0,
      y: 0,
      p_x: 0,
      p_y: 0,
      initial_x: 0,
      initial_y: 0,
      mouse_type: 0, //0 旋转，1 拖拽
    };
  },

  methods: {
    
    deviator() {
      let max = document.getElementsByClassName("model-outline-border")[0];
      let min = document.getElementsByClassName("img3dmodels")[0];
      let x, y, x1, y1;
      x = max.clientWidth;
      y = max.clientHeight;
      x1 = min.clientWidth;
      y1 = min.clientHeight;
      console.log(x, y, x1, y1);
      this.deviatorX = (x1 * this.fangm - x) / 2;
      this.deviatorY = (y1 * this.fangm - y) / 2;

      let max_w = max.offsetWidth; //获取元素宽度
      let min_w = min.offsetWidth; //获取元素宽度

      let max_h = max.offsetHeight; //获取元素高度
      let min_h = min.offsetHeight; //获取元素高度

      this.initial_x = (max_w - min_w) / 2;
      this.initial_y = (max_h - min_h) / 2;
      console.log(
        this.deviatorX,
        this.deviatorY,
        this.initial_x,
        this.initial_y
      );
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    getwin() {
      var self = this;
      function transformScreen() {
        if (window.orientation === 180 || window.orientation === 0) {
          // alert('竖屏状态！');
          setTimeout(() => {
            self.winsize();
          }, 200);
        }
        if (window.orientation === 90 || window.orientation === -90) {
          // alert('横屏状态！');
          setTimeout(() => {
            self.winsize();
          }, 200);
        }
      }
      window.addEventListener(
        "onorientationchange" in window ? "orientationchange" : "resize",
        transformScreen,
        false
      );
    },

    winsize() {
      let model = document.getElementsByClassName("img3dmodels")[0];
      let content = document.getElementsByClassName("model-outline-border")[0];
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      var height =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;
      if (width > height) {
        this.length = height;
      } else {
        this.length = width;
      }
      model.style.width = `${this.length}px`;
      model.style.height = `${this.length}px`;
      content.style.width = `${this.length}px`;
      content.style.height = `${this.length}px`;
      console.log(width, height, `${this.length}px`, this.isPhone);
    },
    toPoint(percent) {
      var str = percent.replace("%", "");
      str = str.toString();
      return str;
    },
    animate() {
      // 动画函数
      window.requestAnimationFrame(() => this.animate());
      TWEEN.update();
    },
    cutscene(start, end, parameter) {
      // 转场动画
      console.log(
        "转场动画 ===>>",
        start,
        end,
        parameter,
        Math.abs((start - end) * 10)
      );
      let self = this;
      var tween = new TWEEN.Tween({ imgindex: start });
      tween.to({ imgindex: end }, Math.abs((start - end) * 10));
      tween.onUpdate(function (obj) {
        //  console.log(this.imgindex.toFixed(0));
        self.n = this.imgindex.toFixed(0); //设定主图
        self.imgpath();
      });
      tween.onComplete(function () {
        // console.log('结束');
        self.animation_list = parameter; //设定动画列表
        console.log(self.animation_list, parameter);
      });
      tween.easing(TWEEN.Easing.Cubic.InOut);
      tween.start();
    },
    removeanimation() {
      //清空动画
      this.RightBtnIndex = null;
      this.animation_list = [];
    },

    setanimation(parameter, imgIndex, index) {
      // console.log(parameter[0].cttype);
      this.removeanimation(); // 清空动画
      this.stoprotating(); // 停止旋转
      // this.n = imgIndex; //设定主图
      this.RightBtnIndex = index;
      // this.newgb = parameter[0].cttype == undefined ? false : true;
      // console.log(this.newgb, parameter[0].cttype);
      this.cutscene(this.n, imgIndex, parameter);
      // this.animation_list = parameter; //设定动画列表
    },

    // 模型旋转
    stoprotating() {
      //停止
      clearInterval(this.interval);
      this.rotatingtype = false;
    },
    startrotating() {
      //旋转
      this.removeanimation();
      if (!this.rotatingtype) {
        this.interval = setInterval(() => {
          this.n -= 1;
          this.n < 0 ? (this.n = 63) : this.n;
          // this.n < 200 ? this.n : (this.n = 0);
          this.imgpath();
        }, 120);
        this.rotatingtype = true;
      }
    },

    formatZero(num, length) {
      // 获取动态文件名称
      //num:要处理的参数
      // length: 要返回的总长度
      return (Array(length).join(0) + num).slice(-length);
    },

    // 预加载图片
    loadimg() {
      for (let index = 0; index < this.imglist.length; index++) {
        const element = this.imglist[index];
        let img = new Image();
        img.src = element;
      }
    },
    LoadingImageList() {
      this.loading = 0;
      // this.loadingindex = 0;
      this.imgs = [];
      let model = document.getElementsByClassName("img3dmodels")[0];
      // console.log(model);
      this.imgs = model.querySelectorAll("img"); //获取模型节点下的所有图片
      // console.log(this.imgs);
      Array.from(this.imgs).forEach((item) => {
        let img = new Image();
        img.onload = () => {
          this.loading++;
          this.loadingindex = (this.loading / 65) * 100;
        };
        img.src = item.getAttribute("src");
      });
      console.log(this.floorplanlist);
    },
    // 生成图片文件列表
    getlist() {
      var filenumber = 65; //文件数量
      let m_ist = [];
      for (let index = 0; index < filenumber; index++) {
        //   const element = array[index];091-Neu atNovena_00000
        let url = require(`@/assets/model/${this.formatZero(index, 5)}.png`);
        // console.log(url);
        this.imglist.push(url);
      }
      //   console.log(m_ist)
      // this.imglist = m_ist;
      // this.loadimg();
    },

    imgpath() {
      // 设定图片路径
      this.imgeurl = this.imglist[this.n];
    },

    rotating(left, width_w) {
      // console.log("asdasd", left, this.positionY_1);
      this.removeanimation();
      this.stoprotating(); // 停止旋转
      //旋转函数
      // left当前传入的位置
      // width_w 最大宽度
      console.log(left, width_w);

      if (left && width_w) {
        // console.log(left, this.positionY_1, width_w, mom);
        if (left > this.positionY_1) {
          // console.log("==========>>右转", left, this.positionY_1);
          this.n -= 1;
          this.n > 0 ? this.n : (this.n = 63);
          // console.log("减", left, this.positionY_1);
          this.imgpath();
          // console.log(this.img_url);
          this.positionY_1 = left;
        } else if (left < this.positionY_1) {
          // console.log("====>>左转", left, this.positionY_1);
          this.n += 1;
          this.n < 63 ? this.n : (this.n = 0);
          // console.log("加", left, this.positionY_1);
          this.imgpath();
          // console.log(this.img_url);
          this.positionY_1 = left;
        }
      } else {
        console.log("超出元素范围");
      }
    },
    zoomremove() {
      document.onmousemove = null;
      document.onmouseup = null;
      document.onmousewheel = null;
      this.positionY_1 = 0;
    },
    zoomsize(e) {
        console.log("鼠标缩放操作===>>>", this.fangm);
        if (e.wheelDelta < 0) {
          // console.log("-");
          this.fangm > 1 ? (this.fangm -= 0.1) : 1;
          this.$refs.img3dmodels.style.transform = "scale(" + this.fangm + ")";
        } else {
          // console.log("+");
          this.fangm < 7 ? (this.fangm += 0.1) : 7;
          this.$refs.img3dmodels.style.transform = "scale(" + this.fangm + ")";
        }
        // this.deviator();
    },
    // 鼠标手势处理
    move(e) {
      let firstTime, lastTime;
      firstTime = new Date().getTime();
      // let op = e.target; //获取目标元素
      let op = document.getElementsByClassName("img3dmodels")[0];
      let width_w = op.offsetWidth; //获取元素宽度
      //   document.onmousedown = (e) => {
      //     console.log(365);
      //   };
      let newtop = op.offsetTop;
      let newleft = op.offsetLeft;

      //算出鼠标相对元素的位置,
      // let x = e.clientX - newleft;
      // let y = e.clientY - newtop;
      // let x = e.clientX - newleft;
      // let y = e.clientY - newtop;
      let x1 = e.clientX;
      let y1 = e.clientY;
      document.onmousemove = (e) => {
        lastTime = new Date().getTime();
        if (lastTime - firstTime > 200) {
          if (this.mouse_type == 1) {
            e.stopPropagation();

            let left = (this.x + e.clientX - x1) / 2;
            let top = (this.y + e.clientY - y1) / 2;

            //绑定元素位置到positionX和positionY上面
            console.log("元素跟随鼠标移动的位置===", left, top);

            if (top > this.deviatorY) {
              this.y = this.deviatorY; // > 0 ? 0 : top; 限制拖动范围
            } else if (top < this.deviatorY * -1) {
              this.y = this.deviatorY * -1; // > 0 ? 0 : top; 限制拖动范围
            } else {
              this.y = top;
            }

            if (left > this.deviatorX) {
              this.x = this.deviatorX; // > 0 ? 0 : top; 限制拖动范围
            } else if (left < this.deviatorX * -1) {
              this.x = this.deviatorX * -1; // > 0 ? 0 : top; 限制拖动范围
            } else {
              this.x = left;
            }
            console.log(this.x, this.y);
          } else {
            //算出鼠标相对元素的位置
            let left = e.clientX - op.offsetLeft;
            let top = e.clientY - op.offsetTop;
            //鼠标按下并移动的事件
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            console.log(width_w);

            this.rotating(left, width_w);
          }
        }
      };
      document.onmouseup = (e) => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.positionY_1 = 0;
      };
      // document.onmousewheel = (e) => {
      //   // 鼠标滚轮事件
      //   let op = document.getElementsByClassName("img3dmodels")[0]; //获取操作元素
      //   var eleW = op.offsetWidth;
      //   var eleH = op.offsetHeight;
      //   console.log("鼠标缩放操作===>>>", this.fangm);

      //   if (e.wheelDelta < 0) {
      //     // console.log("-");
      //     this.fangm > 1 ? (this.fangm -= 0.1) : 1;
      //     op.style.transform = "scale(" + this.fangm + ")";
      //   } else {
      //     // console.log("+");
      //     this.fangm < 7 ? (this.fangm += 0.1) : 7;
      //     op.style.transform = "scale(" + this.fangm + ")";
      //   }

      //   this.deviator()
      // };
    },

    formatZero(num, length) {
      // 获取动态文件名称
      //num:要处理的参数
      // length: 要返回的总长度
      return (Array(length).join(0) + num).slice(-length);
    },

    getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    phonetouchmove(e) {
      let as = document.getElementsByClassName("img3dmodels")[0]; //获取操作元素
      // document.touchmove = (test) => {
      //   console.log("dddd");
      // };
      if (e.touches.length == 1) {
        if (this.mouse_type == 1) {
          let left = e.targetTouches[0].clientX - this.p_x;
          let top = e.targetTouches[0].clientY - this.p_y;
          // this.Drag(op, top, left); //拖动元素
          if (top > this.deviatorY) {
            this.y = this.deviatorY; // > 0 ? 0 : top; 限制拖动范围
          } else if (top < this.deviatorY * -1) {
            this.y = this.deviatorY * -1; // > 0 ? 0 : top; 限制拖动范围
          } else {
            this.y = top;
          }

          if (left > this.deviatorX) {
            this.x = this.deviatorX; // > 0 ? 0 : top; 限制拖动范围
          } else if (left < this.deviatorX * -1) {
            this.x = this.deviatorX * -1; // > 0 ? 0 : top; 限制拖动范围
          } else {
            this.x = left;
          }
        } else {
          console.log("滑动---");
          let op = e.target; //获取目标元素 phone
          let width_w = op.offsetWidth; //获取元素宽度
          //算出鼠标相对元素的位置
          let left = e.targetTouches[0].pageX;
          let top = e.targetTouches[0].pageY;
          // console.log(width_w);
          this.rotating(left, width_w);
        }
      }
      if (e.touches.length == 2) {
        console.log("缩放---");
        var now = e.touches;
        var scale =
          this.getDistance(now[0], now[1]) /
          this.getDistance(this.start[0], this.start[1]);
        console.log("获得缩放比例---", scale);

        scale = scale.toFixed(2);
        console.log("比例取整---", scale);
        // scale >= 0.5 ? scale : 0.5;
        as.style.transform = "scale(" + scale + ")";
        this.fangm = scale;
        this.deviator();
      }
    },
    phonetouchstart(e) {
      console.log("手指按下开始执行---");
      let op = document.getElementsByClassName("img3dmodels")[0];
      let htmls = document.querySelector("html");
      htmls.style = "overflow:hidden;height:100%;";
      if (e.touches.length == 2) {
        //判断是否有两个点在屏幕上
        console.log("双指---");
        this.start = e.touches; //得到第一组两个点
      }
      if (e.touches.length == 1) {
        // console.log("单指---");
        this.p_x = e.targetTouches[0].clientX - op.offsetLeft;
        this.p_y = e.targetTouches[0].clientY - op.offsetTop;
        console.log(this.x, this.y);

        // let x = e.targetTouches[0].pageX;
        // let y = e.targetTouches[0].pageY;
      }
    },
    phonetouchend() {
      console.log("结束操作---");
      let htmls = document.querySelector("html");
      htmls.style = "overflow: visible;";
      // this.x = 0;
      // this.y = 0;
    },
    goUnit(item) {
      // this.nowUnit = this.FloorplanData[item]
      if(item.mediaType){
        console.log(999);
        this.popMedia = item
      }else{
        this.$router
        .push({
          path: '/Unit',
          query: {
            unit: item.type,
          },
        })
        .catch((err) => {});
      }

    },
  },

  watch: {
    n(val, oldval) {
      console.log(val);
    },

    imglist() {
      // 监听楼栋图片列表
      this.$nextTick(() => {
        this.LoadingImageList(); //加载图片
      });
    },
    loadingindex(val, oldval) {
      // 终止加载动画
      if (val == 100) {
        this.loadingindex = false;
        // console.log(val);
      }
    },
  },

  mounted() {
    this.winsize();
    this.getlist();
    this.animate();
    this.getwin();
    this.deviator();

    // 手机 PC处理
    var browser = {
      versions: (function () {
        var u = navigator.userAgent,
          app = navigator.appVersion;
        console.log(u);
        return {
          //移动终端浏览器版本信息
          trident: u.indexOf("Trident") > -1, //IE内核
          presto: u.indexOf("Presto") > -1, //opera内核
          webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
          mobile:
            !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
          android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
          iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
          iPad: u.indexOf("iPad") > -1, //是否iPad
          webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
        };
      })(),
    };
    if (
      browser.versions.ios ||
      browser.versions.android ||
      browser.versions.iPhone ||
      browser.versions.iPad
    ) {
      this.isPhone = true;
    } else {
      this.isPhone = false;
    }
  },
};
</script>

<style lang="less">

.clickRightShow {
  background-color: #444 !important;
  color: #dccfbe !important;
}
.clickbtns {
  // border-bottom: 1px solid #444;
  text-decoration: underline !important; /* 添加下滑线 */
  font-weight: 600;
  font-size: 16px;
  // background-color: #c2c2c2 !important;
}

.rightclickbtn {
  color: #d5c2ac !important;
}
.right-bar {
  position: absolute;
  right: 0px;
  z-index: 201;
  width: 30%;
  height: 100%;
  overflow: auto;
  background: rgb(0 0 0 / 56%);
}
.right-bar-btn-div {
  line-height: 30px;
  letter-spacing: 2px;
  color: #ddd;
  font-weight: 700;
  border-radius: 15px;
  align-items: center;
  display: flex;
  padding-left: 13px;
  text-align: start;
}

.right-bar-btn_header {
  padding: 4px 0;
}
.right-bar-btn_header ul {
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 2px;
  margin-inline-end: 10px;
}

.right-bar-btn_header ul li {
  padding: 4px;
  list-style-type: none;
}

.right-round_btn_div {
  font-weight: 700;
  line-height: 30px;
  background: rgba(0, 0, 0, 0.3);
  color: #ddd;
  border-radius: 15px;
  /* height: 30px; */
  align-items: center;
  display: grid;
  justify-content: start;
  padding-left: 13px;
  text-align: start;
}

#animation_div {
  position: absolute;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}
.animation_for_size_div {
  color: white;
  /* font-size: x-large; */
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
}

.loading_div {
  width: 100vw;
  height: 93%;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  background: rgba(0, 0, 0, 0.288);
}
.model-outline-border{
  position: relative;
}
.pro_page_models_div {
  // background-color: white;
  width: calc(83% - 75px);
  margin: 20px;
  margin-right: 55px;
  height: calc(100% - 40px);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* top: 10px;
  right: 10px; */
  // position: absolute;
  overflow: hidden;
}

.img3dmodels {
  position: relative;
  width: 800px;
  height: 800px;
  transform: scale(1.2);
  font-size: x-small;
  display: flex;
  justify-content: center;
  align-items: center;
}


.logo {
  width: 185px;
  line-height: 15px;
  border-radius: 10px;
  /* padding: 20px; */
  /* background: #000; */
  height: auto;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pro_page_content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.pro_page_header_div {
  width: calc(17% - 40px);
  padding: 20px;
  height: calc(100% - 40px);
  // left: 15px;
  // top: 15px;
  z-index: 200;
  overflow: auto;
  cursor: pointer;
  /* font-family: Regular;  */
}
.btn_list {
  width: 100%;
  /* display: list-item; */
  font-size: 12px;
  margin-top: 25px;
}

.round_btn_div {
  // line-height: 25px;
  margin: 5px 0;
  font-weight: 600;
  font-size: 15px;
  /* background: #544433; */
  color: black;
  // border-radius: 3px;
  /* height: 30px; */
  /* align-items: center;
  display: grid;
  justify-content: start; */
  // padding-left: 13px;
  text-align: start;
  // border: 1px solid black;
}

.round_btn_div:hover {
  cursor: pointer;
  -webkit-touch-callout: none;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}

.btn_header {
  // padding: 4px 0;
}
.btn_header ul li {
  width: 80%;
  padding: 4px;
  list-style-type: none;
}
.btn_header ul {
  width: 100%;
  overflow: auto;
  max-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-inline-start: 0px;
  margin-block-end: auto;
  /* padding-inline-start: 0px; */
  margin-block-start: 0px;
  margin: 2px 0;
}


@media screen and (max-width: 800px) {
  .animation_for_size_div span {
    /* transform: scale(0.5); */
  }
  .img3dmodels {
    position: absolute;
    bottom: 25px;
  }
  .logo {
    width: 85px;
  }
  .pro_page_header_div {
    width: 125px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .round_btn_div {
    line-height: 16px !important;
  }
  .btn_header ul {
    padding-inline-start: 20px;
  }
}

.phone {
  right: 30% !important;
}
.phone div {
  padding: 0px !important;
}
@media screen and (max-height: 800px) {
  /* .img3dmodels {
    width: 400px;
    height: 400px;
  } */
  .logo {
    width: 85px;
  }
  .pro_page_header_div {
    display: flex;
    flex-flow: column;
    align-items: center;
  }
}
</style>
